import React from "react";
import { motion } from "framer-motion";
import { TID } from "@/constants/testIds";

const bookBanner =
  "https://customer-assets.emergentagent.com/job_mare-method-shop-1/artifacts/box8waq0_WhatsApp%20Image%202026-05-15%20at%2014.23.54.jpeg";

export default function AuthorBio() {
  return (
    <section
      id="author"
      data-testid={TID.authorSection}
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#F4E8D6] to-[#E8D5B7] border-t border-[#E5E1DA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="md:col-span-5"
          >
            <div className="relative aspect-[3/4] overflow-hidden border border-[#0B192C]/10">
              <img
                src={bookBanner}
                alt="Michele Roccaro — autore di Metodo di Mare"
                className="w-full h-full object-cover"
                data-testid="author-portrait"
              />
            </div>
            <div className="mt-6 grid grid-cols-2 gap-6">
              <div>
                <p className="overline">Marina Militare</p>
                <p className="font-serif-display text-2xl mt-2">9 anni</p>
                <p className="text-xs text-[#3A4F6B] mt-1">Amerigo Vespucci</p>
              </div>
              <div>
                <p className="overline">Ruolo</p>
                <p className="font-serif-display text-2xl mt-2">Presidente</p>
                <p className="text-xs text-[#3A4F6B] mt-1">ONLUS · A.C.D.T.</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="md:col-span-6 md:col-start-7"
          >
            <p className="overline">L'Autore</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              Michele
              <br />
              <em className="text-[#E89B6C]">Roccaro.</em>
            </h2>

            <div className="mt-8 space-y-6 text-lg font-light leading-relaxed text-[#3A4F6B]">
              <p>
                Per nove anni imbarcato sull'
                <strong className="text-[#0B192C] font-normal">
                  Amerigo Vespucci
                </strong>
                , la nave scuola della Marina Militare Italiana. Una scuola di
                disciplina, silenzio e responsabilità che è diventata il
                fondamento del suo metodo.
              </p>
              <p>
                Dopo l'esperienza in mare, anni nella vendita diretta e nello
                sviluppo di reti commerciali. Oggi imprenditore digitale,
                consulente e formatore in leadership, sicurezza digitale e
                metodo organizzativo. Presidente di una ONLUS, attivo in progetti
                di inclusione sociale e formazione professionale.
              </p>
              <p>
                La sua vocazione è accompagnare gli altri a diventare
                professionisti completi, unendo etica, competenza e metodo —
                figura riconosciuta dalla Legge 4/2013 tramite A.C.D.T.
              </p>
            </div>

            <blockquote className="mt-10 pl-6 border-l border-[#D4B895]">
              <p className="font-serif-display italic text-2xl md:text-3xl leading-snug text-[#0B192C]">
                "La libertà è il mare verso l'orizzonte, con le persone più
                importanti della mia vita accanto. La mia libertà è aiutare
                gli altri."
              </p>
              <p className="mt-4 overline text-[#3A4F6B]">
                — Michele Roccaro · Il motto
              </p>
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
